// removed by extract-text-webpack-plugin
module.exports = {"statusButton":"statusButton___2EECC","pending":"pending___3BxUn","processing":"processing___2YGvG","sent":"sent___1GPWr","redeemed":"redeemed___20TPI","failed":"failed___1ejfI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MediaList/RewardButton.module.less
// module id = 3398
// module chunks = 33